import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=711c7d7f&scoped=true"
import script from "./bar-chart.vue?vue&type=script&lang=js"
export * from "./bar-chart.vue?vue&type=script&lang=js"
import style0 from "./bar-chart.vue?vue&type=style&index=0&id=711c7d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711c7d7f",
  null
  
)

export default component.exports